// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-weight: 300;
  margin-top: 10px;
  margin-bottom: 20px;
}

.card {
  padding: 20px;
}

.cartao {
  float: right;
}
.cartao .final-cartao {
  float: right;
}
.cartao .bandeira-cartao {
  margin-top: -5px;
  float: left;
}

.nome-comprador {
  float: left;
}

ul.menu-cliente {
  list-style-type: none;
  padding-top: 20px;
  padding-left: 0;
  border-bottom: 2px solid #cccccc;
}
ul.menu-cliente li {
  display: inline-block;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 700;
  color: #999999;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
ul.menu-cliente li.active {
  color: #6a5cff;
  border-bottom: 2px solid #6a5cff;
  margin-bottom: -2px;
}

ul.vendas {
  list-style-type: none;
  padding-left: 0;
}
ul.vendas li.venda {
  border-bottom: 1px solid #cccccc;
  padding: 10px 0;
}
ul.vendas li.venda h2 a {
  color: #777777;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/clientes/cliente/cliente.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACE,YAAA;AAAF;AACE;EACE,YAAA;AACJ;AACE;EACE,gBAAA;EACA,WAAA;AACJ;;AAGA;EACE,WAAA;AAAF;;AAGA;EACI,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AAAJ;AACI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cClBI;EDmBJ,yBAAA;UAAA,iBAAA;EACA,eAAA;AACR;AACI;EACI,cC/BE;EDgCF,gCAAA;EACA,mBAAA;AACR;;AAIA;EACI,qBAAA;EACA,eAAA;AADJ;AAEI;EACI,gCAAA;EACA,eAAA;AAAR;AAEY;EACI,cCvCJ;ADuCZ","sourcesContent":["@import '../../../../../../sass/variables';\nh2 {\n    font-weight: 300;\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.card {\n    padding: 20px;\n}\n\n.cartao {\n  float: right;\n  .final-cartao {\n    float: right;\n  }\n  .bandeira-cartao {\n    margin-top: -5px;\n    float: left;\n  }\n}\n\n.nome-comprador {\n  float: left;\n}\n\nul.menu-cliente {\n    list-style-type: none;\n    padding-top: 20px;\n    padding-left: 0;\n    border-bottom: 2px solid $cinza-400;\n    li {\n        display: inline-block;\n        padding: 12px 20px;\n        font-size: 16px;\n        font-weight: 700;\n        color: $cinza-500;\n        user-select: none;\n        cursor: pointer;\n    }\n    li.active {\n        color: $violeta;\n        border-bottom: 2px solid $violeta;\n        margin-bottom: -2px;\n    }\n\n}\n\nul.vendas {\n    list-style-type: none;\n    padding-left: 0;\n    li.venda {\n        border-bottom: 1px solid $cinza-400;\n        padding: 10px 0;\n        h2 {\n            a {\n                color: $cinza-600;\n            }\n        }\n    }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
